import * as types from '../actiontypes';
import {createApiReadAction, API_RESOURCES} from '../../util/api';
import {promiseAreas} from '../../util/uiconstants';

export const DocumentByIdValidExpands = {
	tasks: 'tasks',
	relatedDocuments: 'relatedDocuments',
	versions: 'versions',
	conflicts: 'conflicts'
};

/**
 * Dispatches a Document GetById action with the specified query string parameters and action payload.
 * @param {Number} engagementId Engagement Id.
 * @param {String} documentId Document Id.
 * @param {Object} queryString Query string parameters.
 * @param {boolean} isAresView. true - If it is guided workflow, false - If it is kronos.
 * @param {Object} payload Action payload. Extra properties to be included in the action.
 * @returns Document GetById API action.
 */
export function getDocumentByDocumentId(engagementId, documentId, queryString, isAresView, payload, actionType) {
	let actionPayload = {...payload} || {};

	if (queryString) {
		actionPayload.payload = queryString;
	}

	return createApiReadAction(
		actionType || types.ARES_GET_DOCUMENT_BY_ID,
		{[API_RESOURCES.ENGAGEMENTS]: engagementId, [API_RESOURCES.DOCUMENTS]: documentId},
		queryString,
		{
			...actionPayload,
			resolve: true,
			isAresView
		},
		undefined,
		promiseAreas.FIT_BREADCRUMB
	);
}

export function updateTaskDocumentOnChangeReason(document) {
	return {
		type: types.ARES_UPDATE_TASK_DOCUMENT_ON_CONFIRM_CHANGE_REASON,
		documentId: document.id,
		document
	};
}

export function removeAresSignOff(removedApprovalId) {
	return {
		type: types.ARES_REMOVE_SIGN_OFF,
		removedApprovalId
	};
}

export function updateIsShared(taskId, documentId, isShared) {
	return {
		type: types.SET_IS_SHARED,
		taskId,
		documentId: documentId,
		isShared
	};
}

export function updateDocumentStatus(taskId, documentStatusId) {
	return {
		type: types.UPDATE_DOCUMENT_STATUS,
		taskId,
		documentStatusId
	};
}

export function updateIsUnlink(taskId, isUnlink) {
	return {
		type: types.SET_UNLINK_INITIATED,
		taskId,
		isUnlink
	};
}

export function generateNavigationPanelId(taskId, documentId) {
	let panelId = taskId;
	if (documentId) {
		panelId = `${panelId}_${documentId}`;
	}

	return panelId;
}

export function setLeftNavigationActivePanel(panelId) {
	return {
		type: types.SET_LEFT_NAVIGATION_ACTIVE_PANEL,
		panelId
	};
}
